"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerParameterType = exports.TrackerType = exports.ClientParameterType = exports.EventType = exports.protobufPackage = void 0;
exports.protobufPackage = "tracking";
var EventType;
(function (EventType) {
    EventType[EventType["EVENT_UNSPECIFIED"] = 0] = "EVENT_UNSPECIFIED";
    /** EVENT_VISIBLE - some component becomes visible */
    EventType[EventType["EVENT_VISIBLE"] = 1] = "EVENT_VISIBLE";
    /** EVENT_INVISIBLE - some component becomes invisible */
    EventType[EventType["EVENT_INVISIBLE"] = 2] = "EVENT_INVISIBLE";
    /** EVENT_CLICK - some component is clicked */
    EventType[EventType["EVENT_CLICK"] = 3] = "EVENT_CLICK";
    /** SCREEN_VISIBLE - some stream becomes visible */
    EventType[EventType["SCREEN_VISIBLE"] = 4] = "SCREEN_VISIBLE";
    /** VIDEO_PLAYED - video paused/stopped after playback */
    EventType[EventType["VIDEO_PLAYED"] = 5] = "VIDEO_PLAYED";
    /** VIDEO_AD_STARTED - video ad is being played */
    EventType[EventType["VIDEO_AD_STARTED"] = 6] = "VIDEO_AD_STARTED";
    /** EVENT_EXTERNAL - events triggered by third party (e.g. Comments SDK) */
    EventType[EventType["EVENT_EXTERNAL"] = 7] = "EVENT_EXTERNAL";
    EventType[EventType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EventType || (exports.EventType = EventType = {}));
var ClientParameterType;
(function (ClientParameterType) {
    ClientParameterType[ClientParameterType["PARAMETER_UNSPECIFIED"] = 0] = "PARAMETER_UNSPECIFIED";
    /** PARAMETER_VISIBLE_DURATION_SECONDS - visible duration in seconds for the component / experience */
    ClientParameterType[ClientParameterType["PARAMETER_VISIBLE_DURATION_SECONDS"] = 1] = "PARAMETER_VISIBLE_DURATION_SECONDS";
    /** PARAMETER_PREVIOUS_SCREEN - name of the previous screen */
    ClientParameterType[ClientParameterType["PARAMETER_PREVIOUS_SCREEN"] = 2] = "PARAMETER_PREVIOUS_SCREEN";
    /** PARAMETER_OPENING_SOURCE - name of the opening source */
    ClientParameterType[ClientParameterType["PARAMETER_OPENING_SOURCE"] = 3] = "PARAMETER_OPENING_SOURCE";
    /** PARAMETER_DISPLAY_MODE - "dark"/"light" */
    ClientParameterType[ClientParameterType["PARAMETER_DISPLAY_MODE"] = 4] = "PARAMETER_DISPLAY_MODE";
    /** PARAMETER_SCROLL_TO_BOTTOM - is element/stream scrolled to the bottom ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_SCROLL_TO_BOTTOM"] = 5] = "PARAMETER_SCROLL_TO_BOTTOM";
    /** PARAMETER_VIDEO_FINISHED - is video playback finished ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_VIDEO_FINISHED"] = 6] = "PARAMETER_VIDEO_FINISHED";
    /** PARAMETER_VIDEO_PLAYBACK_DURATION_SECONDS - time span between play and pause/stop */
    ClientParameterType[ClientParameterType["PARAMETER_VIDEO_PLAYBACK_DURATION_SECONDS"] = 7] = "PARAMETER_VIDEO_PLAYBACK_DURATION_SECONDS";
    /** PARAMETER_DATE_CHOSEN - number of days from today ("0" for today, "+1" for tomorrow, "-1" for yesterday) */
    ClientParameterType[ClientParameterType["PARAMETER_DATE_CHOSEN"] = 8] = "PARAMETER_DATE_CHOSEN";
    /** PARAMETER_MATCH_EVENTS_TOGGLED - is match events expand button toggled ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_MATCH_EVENTS_TOGGLED"] = 9] = "PARAMETER_MATCH_EVENTS_TOGGLED";
    /** PARAMETER_MATCH_LINEUP_SIDE_TOGGLED - is match lineup side toggled ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_MATCH_LINEUP_SIDE_TOGGLED"] = 10] = "PARAMETER_MATCH_LINEUP_SIDE_TOGGLED";
    /** PARAMETER_MATCH_PREDICTION_USER_VOTED - has user voted ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_MATCH_PREDICTION_USER_VOTED"] = 11] = "PARAMETER_MATCH_PREDICTION_USER_VOTED";
    /** PARAMETER_VIDEO_ENTERED_FULLSCREEN_MODE - the video entered fullscreen mode ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_VIDEO_ENTERED_FULLSCREEN_MODE"] = 12] = "PARAMETER_VIDEO_ENTERED_FULLSCREEN_MODE";
    /** PARAMETER_SCROLL_TO_END_OF_SECTION - is element/stream scrolled to the end of a section ("true"/"false") */
    ClientParameterType[ClientParameterType["PARAMETER_SCROLL_TO_END_OF_SECTION"] = 13] = "PARAMETER_SCROLL_TO_END_OF_SECTION";
    ClientParameterType[ClientParameterType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ClientParameterType || (exports.ClientParameterType = ClientParameterType = {}));
var TrackerType;
(function (TrackerType) {
    TrackerType[TrackerType["TRACKER_UNSPECIFIED"] = 0] = "TRACKER_UNSPECIFIED";
    TrackerType[TrackerType["TRACKER_FIREBASE"] = 1] = "TRACKER_FIREBASE";
    TrackerType[TrackerType["TRACKER_LOCALYTICS"] = 2] = "TRACKER_LOCALYTICS";
    TrackerType[TrackerType["TRACKER_ADJUST"] = 3] = "TRACKER_ADJUST";
    TrackerType[TrackerType["TRACKER_AIRSHIP"] = 4] = "TRACKER_AIRSHIP";
    TrackerType[TrackerType["TRACKER_SNOWPLOW"] = 5] = "TRACKER_SNOWPLOW";
    TrackerType[TrackerType["TRACKER_GOOGLE"] = 6] = "TRACKER_GOOGLE";
    TrackerType[TrackerType["TRACKER_FACEBOOK"] = 7] = "TRACKER_FACEBOOK";
    TrackerType[TrackerType["TRACKER_RUDDERSTACK"] = 8] = "TRACKER_RUDDERSTACK";
    TrackerType[TrackerType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TrackerType || (exports.TrackerType = TrackerType = {}));
var ServerParameterType;
(function (ServerParameterType) {
    ServerParameterType[ServerParameterType["UNKNOWN"] = 0] = "UNKNOWN";
    ServerParameterType[ServerParameterType["FLOAT"] = 1] = "FLOAT";
    ServerParameterType[ServerParameterType["STRING"] = 2] = "STRING";
    ServerParameterType[ServerParameterType["BOOLEAN"] = 3] = "BOOLEAN";
    ServerParameterType[ServerParameterType["INTEGER"] = 4] = "INTEGER";
    ServerParameterType[ServerParameterType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ServerParameterType || (exports.ServerParameterType = ServerParameterType = {}));
//# sourceMappingURL=tracking.js.map